import {Component, OnInit} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";
import {Order} from "../../../../../../common/interfaces/order.interface";


@Component({
    selector: "section-order-list-all-by-item",
    template: `
        <section-order-list-by-item [params]="params"></section-order-list-by-item>`
})
export class OrderListAllByItemComponent implements Base.IComponent, OnInit {

    public readonly state: Base.IState;

    public params: Order.IOrderListParams;

    public constructor() {
    }

    public ngOnInit(): void {
        this.params = {
            title: "Orders list by items",
            state: this.state,
            actions: {
                view: true,
                delete: true,
                add: false,
                export: true,
                remarks: true
            }
        };
    }

    public ngConfig(): Base.IConfig {
        return {
            name: "orders-by-item",
            actions: {
                "browse": ["browse_orders"]
            }
        };
    }

}
